import React from 'react';
import PropTypes from 'prop-types';

import s from './selectCheckmark.module.css';

export const SelectCheckmark = ({ selected }) => (
  <select-checkmark>
    <svg
      id="select_svg"
      className={`narvar-checkmark ${s.checkmark} ${selected ? 'checkmark-selected' : ''}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      aria-label={selected ? 'selected' : 'unselected'}
      role="img"
    >
      <style dangerouslySetInnerHTML={{ __html: '.st0{fill:#ccc}.st1{fill:none}' }} />
      <path className="checkmark-fill st1" d="M39 37.6V1H2.4z" />
      <path
        className={`checkmark checkmark-outline ${s.checkmark_path} st0`}
        d="M0 0l28 28 12 12V0H0zm39 37.6L2.4 1H39v36.6z"
      />
      <path
        className={`checkmark checkmark-icon ${s.checkmark_path} st0`}
        d="M25.5 15.5L22 12l-1.2 1.2 4.7 4.6 10-10-1.2-1.1z"
      />
    </svg>
  </select-checkmark>
);

SelectCheckmark.propTypes = {
  selected: PropTypes.bool.isRequired,
};
